import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AtRiskMembersAlert = ({ members }) => {
  return (
    <div className="card border-l-4 border-l-warning">
      <div className="flex items-start gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-warning/10 flex items-center justify-center flex-shrink-0">
          <Icon name="AlertTriangle" size={24} color="var(--color-warning)" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
            At-Risk Members Alert
          </h3>
          <p className="text-sm text-muted-foreground">
            {members?.length} members showing signs of potential churn based on AI analysis
          </p>
        </div>
      </div>
      <div className="space-y-3 mb-6">
        {members?.slice(0, 3)?.map((member, index) => (
          <div 
            key={index} 
            className="flex items-center justify-between p-3 rounded-lg bg-muted/50"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                <span className="text-sm font-semibold text-primary">
                  {member?.name?.split(' ')?.map(n => n?.[0])?.join('')}
                </span>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">{member?.name}</p>
                <p className="text-xs text-muted-foreground">{member?.reason}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-xs font-medium text-warning">{member?.riskScore}% risk</span>
              <Icon name="ChevronRight" size={16} color="var(--color-muted-foreground)" />
            </div>
          </div>
        ))}
      </div>
      <Button variant="outline" fullWidth iconName="Users" iconPosition="left">
        View All At-Risk Members
      </Button>
    </div>
  );
};

export default AtRiskMembersAlert;